import styled from 'styled-components';

export const ContainerDiv = styled.div`
    text-align: center;
    margin-top: 8rem;
`;
